const jobTextFieldModule = {
  id: "03d91651-1ef7-4465-8257-2cbbbf6c718e",
  component: "CRJobTextField",
  config: {
    key: "module-job-text-field",
    general: {
      blockWidth: {
        label: "Full",
        value: "full",
      },
      template: {
        label: "Left Aligned",
        component: "JobTextFieldLeft",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      backgroundColor: {
        key: "default-white",
        label: "White",
        value: "#FFFFFF",
      },
      media: {
        uuid: null,
        url: "https://tc-media.job-shop.com/content-modules/image-and-text/image/image-and-text-image.jpg",
        mediaType: "image",
      },
      showMedia: false,
      showHeader: true,
      analytics: {
        label: "Not specified",
        value: "not-specified",
      },
      text: {
        offerField: {
          label: "Introduction",
          value: "introduction",
        },
        textColor: {
          key: "default-black",
          label: "Black",
          value: "#161616",
        },
      },
    },
    header: {
      isTextInCaps: true,
      text: "Description",
      textColor: {
        key: "default-black",
        label: "Black",
        value: "#161616",
      },
    },
  },
};

export default jobTextFieldModule;
